// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___3H_yY","inner":"styles__inner___2GBla","imageCol":"styles__imageCol___2s7SB","title":"styles__title___3iBOr","postedOn":"styles__postedOn___1DUMK","rotate":"styles__rotate___2831a","fadein":"styles__fadein___3py8f","slideFromRight":"styles__slideFromRight___1yxjL","waves":"styles__waves___3P8KY"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/Card/styles.scss
// module id = ./resources/assets/js/components/Card/styles.scss
// module chunks = 0